import { Form, Row, Col, Button, FormInstance, message, InputNumber, Descriptions } from 'antd';
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getDataInfo, stepperMoving } from '../../stores/actions';
import { getApi, patchApi } from '../../../../shared/src/apis';
import { UserInfoUI } from '@operations/shared';
import helper from '../../utils/helper';
import { getRegion } from '../../components/regionWrapper';
import { Region } from '../../utils/commonInterfaces';

interface Props {
    getApi?: any,
    info?: {
        name: string,
        companyName: string,
        phone: string,
        email: string,

        consent: [],
        nationalId: any,
        hrLetter: [],
        accountCreatedAt: string,
        bankAccountHolderName: string,
        bankAccountNumber: string,
        bankName: string,

        userStatus: string,
        userStatusType: string,

        maxAdvancePercentAllowedPerCompany: number,
        departmentMaxAdvanceAllowedPercent?: number | null,
        companyMaxAdvanceAllowedPercent?: number | null,
        activeMaxAdvanceAllowedPercent?: number | null,
        maxBalance: number,
        maxShoppingBalnce: number,

        wallet: number,
        staff_id: string,
        companyMaxInstallmentCount: number,
        nationalIDNumber: string,
        netSalary: any,
        userID: any,
        userMaxAdvanceAllowedPercent?: number | null,
        endOfServiceBenefit?: number | null,
    }
    patchApi?: any,
    stepperMoving?: any,
    fromViewUserAction?: boolean,
    getDataInfo: any,
}
class UserSalary extends Component<Props> {
    state = {
        loadData: false
    }
    formRef = React.createRef<FormInstance>();
    region = getRegion();


    changeUserSalary = async (values: { netSalary: number, maxAdvancePercentAllowed?: number, endOfServiceBenefit?: number  }) => {
        this.setState({ loadData: true })

        const data = {
            userID: this.props?.info?.userID,
            netSalary: values?.netSalary,
            ...(this.region === Region.SE && {
                maxAdvancePercentAllowed: values?.maxAdvancePercentAllowed ? values?.maxAdvancePercentAllowed : null,
                endOfServiceBenefit: values?.endOfServiceBenefit ? values?.endOfServiceBenefit : null,
            }),
        }
        this.setState({ changeSalarySpin: true })
        const endingCall = await this.props.patchApi('users/updateUserSalary', data);

        try {
            const res = endingCall?.payload;
            if (res?.status === 200) {
                this.setState({ changeSalarySpin: false, loadData: false });
                message.success(res?.message);
                if (this.props.fromViewUserAction) {
                    this.props.getDataInfo({ ...this.props?.info, ...data, ...(this.region === Region.SE && { userMaxAdvanceAllowedPercent: data?.maxAdvancePercentAllowed }) });
                    this.props.stepperMoving(1);
                }
                else {
                    helper.resetAccountTableInStepper();
                    this.props.stepperMoving(0);
                }
            }
            else {
                this.setState({ changeSalarySpin: false, loadData: false })
                console.log(res.message);
                message.error(res.message)
            }
        } catch (error) {
            this.setState({ changeSalarySpin: false, loadData: false })
            console.log(error);
            message.error('Something went wrong, please try again');

        }

    }
    render() {
        const { info } = this.props;
        const { loadData } = this.state;
        const saudiSalaryInfo: any[] = [
            {
                key: 'User Maximum Advance Percentage Allowed',
                value: <Form.Item
                    name="maxAdvancePercentAllowed"
                    initialValue={info?.userMaxAdvanceAllowedPercent}
                    rules={[
                        {
                            validator: (_, value) => {
                                if (typeof value === 'number' && !Number.isInteger(value)) {
                                    return Promise.reject('User maximum advance percentage must be an integer');
                                }
                                else if (typeof value === 'number' && value < 0) {
                                    return Promise.reject('User maximum advance percentage must be a positive number');
                                }
                                else if (typeof value === 'number' && value > 300) {
                                    return Promise.reject('User maximum advance percentage cannot be more than 300%');
                                }
                                return Promise.resolve();
                            }
                        }
                    ]}
                >
                    <InputNumber type='number' placeholder="Enter the user maximum advance percentage allowed" style={{ width: '100%' }} />
                </Form.Item>
            },
            { key: 'Department Maximum Advance Percentage Allowed', value: this.props.info?.departmentMaxAdvanceAllowedPercent ? this.props.info?.departmentMaxAdvanceAllowedPercent : 'N/A' },
            { key: 'Company Maximum Advance Percentage Allowed', value: this.props.info?.companyMaxAdvanceAllowedPercent ? this.props.info?.companyMaxAdvanceAllowedPercent : 'N/A' },
            { key: 'Active Maximum Advance Percentage Allowed', value: this.props.info?.activeMaxAdvanceAllowedPercent ? this.props.info?.activeMaxAdvanceAllowedPercent : 'N/A' },
            {
                key: 'End of Service Payment',
                value: <Form.Item
                    name="endOfServiceBenefit"
                    initialValue={info?.endOfServiceBenefit}
                    rules={[
                        {
                            validator: (_, value) => {
                                if (typeof value === 'number' && value < 0) {
                                    return Promise.reject('End of service payment must be a positive number');
                                }
                                return Promise.resolve();
                            }
                        }
                    ]}
                >
                    <InputNumber type='number' placeholder="Enter the end of service payment" style={{ width: '100%' }} />
                </Form.Item>
            }
        ]
        const salaryInfo = [
            {
                key: 'Net Salary',
                value: <Form.Item
                    name="netSalary"
                    rules={[{ required: true, message: 'Required' }]}
                    initialValue={info?.netSalary}
                >
                    <InputNumber placeholder="Enter the net salary" style={{ width: '100%' }} />
                </Form.Item>
            },
            ...(this.region === Region.SE ? saudiSalaryInfo : []),
        ]
        return (
            <>
                <Form name="nest-messages" ref={this.formRef} onFinish={this.changeUserSalary}>
                    <Row>
                        <Col span={24}>
                            <UserInfoUI userData={salaryInfo} activeKey={1} header={'Salary Information'} nonEditable={true} collapsible={"disabled"} />
                        </Col>
                        <Col style={{ display: "flex", justifyContent: "flex-end" }} span={24}>
                            <Form.Item>
                                <Button style={{ margin: '30px 0 0 0 ', backgroundColor: "#7CC58F", borderColor: "#7CC58F" }} className='changeUserStatusBtn' shape="round" type="primary" htmlType="submit" loading={loadData} >
                                    Change
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* <Descriptions bordered style={{ marginTop: "25px" }}>
                        <Descriptions.Item label="User ID" span={3}>{info?.userID}</Descriptions.Item>
                        <Descriptions.Item label="Name" span={3}>{info?.name}</Descriptions.Item>
                        <Descriptions.Item label="Phone Number" span={3}>{info?.phone}</Descriptions.Item>
                        <Descriptions.Item label="Company" span={3}>{info?.companyName}</Descriptions.Item>
                        <Descriptions.Item label="Staff ID" span={3}>{info?.staff_id}</Descriptions.Item>
                    </Descriptions> */}
                </Form>
                <Descriptions bordered style={{ marginTop: "25px" }}>
                    <Descriptions.Item label="User ID" span={3}>{info?.userID}</Descriptions.Item>
                    <Descriptions.Item label="Name" span={3}>{info?.name}</Descriptions.Item>
                    <Descriptions.Item label="Phone Number" span={3}>{info?.phone}</Descriptions.Item>
                    <Descriptions.Item label="Company" span={3}>{info?.companyName}</Descriptions.Item>
                    <Descriptions.Item label="Staff ID" span={3}>{info?.staff_id}</Descriptions.Item>
                </Descriptions>
            </>
        )
    }
}
const mapStateToProps = (state: any) => ({
    info: state.actionsReducer.info,
    fromViewUserAction: state.actionsReducer.isViewUserAction,
})
export default connect(mapStateToProps, { getApi, patchApi, stepperMoving, getDataInfo })(UserSalary)
